import type { ControllerFlowAPI } from '@wix/yoshi-flow-editor';

export const isV3enabled = (flowAPI: ControllerFlowAPI) => {
  return flowAPI.experiments.enabled('specs.programs.OOINileMigration');
};

export const isParticipantV3enabled = (flowAPI: ControllerFlowAPI) => {
  return flowAPI.experiments.enabled('specs.programs.OOIParticipantV3');
};
